import React from "react";
import ReactSlider from "react-slider";
import { Icon } from "./";

export function ZoomControlsField({
  min = -5,
  max = 5,
  defaultValue = 0,
  defaultMin = -5,
  defaultMax = 5,
  setField,
}) {
  const parseValuePercent = (val) => {
    let vals = [
      val < 0 ? "-" : val === 0 ? "" : "+",
      val === 0 ? 100 : Math.abs(val) * 100,
      "%",
    ];
    return vals.join("");
  };

  const handleChange = (vals) => {
    // console.log("DEFAULTS: ", defaultMin, defaultMax, defaultValue);
    // console.log("VALUES: ", vals);
    const [newMin, newVal, newMax] = vals;
    if (setField) {
      setField("zoomMin", newMin);
      setField("zoomDefault", newVal);
      setField("zoomMax", newMax);
    }
  };
  return (
    <div className="chronos-zoom-range-slider">
      <ReactSlider
        className="chronos-zoom-slider"
        thumbClassName="chronos-zoom-thumb"
        trackClassName="chronos-zoom-track"
        defaultValue={[defaultMin, defaultValue, defaultMax]}
        onChange={handleChange}
        pearling={true}
        renderThumb={(props, state) => {
          return (
            <div
              {...props}
              className={
                props.className +
                (props.key === "chronos-zoom-thumb-1"
                  ? " chronos-default-thumb"
                  : "")
              }
            >
              <div className="chronos-zoom-thumb-wrapper">
                <span className="chronos-zoom-thumb-icon">
                  <Icon
                    icon={
                      props.key === "chronos-zoom-thumb-1"
                        ? "fas fa-caret-down fa-fw fa-2x"
                        : "fas fa-caret-up fa-fw fa-2x"
                    }
                  />
                </span>
                <span className="chronos-zoom-label">
                  {props.key === "chronos-zoom-thumb-0" && "Min"}
                  {props.key === "chronos-zoom-thumb-1" && "Initial Zoom"}
                  {props.key === "chronos-zoom-thumb-2" && "Max"}
                </span>
                <span className="chronos-zoom-thumb-value">
                  {parseValuePercent(state.valueNow)}
                </span>
              </div>
            </div>
          );
        }}
        minDistance={0}
        min={min}
        max={max}
      />
    </div>
  );
}

// import React, { useState, useRef, useCallback, useEffect } from "react";

// export function ZoomControlsField({ min, max, onChange }) {
//   const [minVal, setMinVal] = useState(min);
//   const [maxVal, setMaxVal] = useState(max);

//   const minValRef = useRef(null);
//   const maxValRef = useRef(null);

//   const rangeRef = useRef(null);

//   const getPercent = useCallback(
//     (val) => {
//       Math.round(((val - min) / (max - min)) * 100);
//     },
//     [min, max]
//   );

//   useEffect(() => {
//     if (maxValRef.current) {
//       const minPercent = getPercent(minVal);
//       const maxPercent = getPercent(+maxValRef.current.value);

//       if (rangeRef.current) {
//         rangeRef.current.style.left = `${minPercent}%`;
//         rangeRef.current.style.width = `${maxPercent - minPercent}%`;
//       }
//     }
//   }, [minVal, getPercent]);

//   useEffect(() => {
//     if (minValRef.current) {
//       const minPercent = getPercent(+minValRef.current.value);
//       const maxPercent = getPercent(maxVal);

//       if (rangeRef.current) {
//         rangeRef.current.style.width = `${maxPercent - minPercent}%`;
//       }
//     }
//   }, [maxVal, getPercent]);

//   useEffect(() => {
//     onChange({ min: minVal, max: maxVal });
//   }, [minVal, maxVal, onChange]);

//   return (
//     <div className="chronos-range-slider">
//       <input
//         type="range"
//         min={min}
//         max={max}
//         value={minVal}
//         ref={minValRef}
//         onChange={(ev) => {
//           const value = Math.min(+ev.target.value, maxVal - 1);
//           setMinVal(value);
//           ev.target.value = value.toString();
//         }}
//         className={`chronos-slider-input chronos-slider-3${
//           minVal > max - 100 && ` chronos-slider-5`
//         }`}
//       />
//       <input
//         type="range"
//         min={min}
//         max={max}
//         value={maxVal}
//         ref={maxValRef}
//         onChange={(ev) => {
//           const value = Math.max(+ev.target.value, minVal + 1);
//           setMaxVal(value);
//           ev.target.value = value.toString();
//         }}
//         className="chronos-slider-input chronos-slider-4"
//       />
//       <div className="chronos-slider">
//         <div className="chronos-slider-track"></div>
//         <div ref={rangeRef} className="chronos-slider-range"></div>
//         <div className="chronos-slider-left-value">{minVal}</div>
//         <div className="chronos-slider-right-value">{maxVal}</div>
//       </div>
//     </div>
//   );
// }
